import React, { FunctionComponent } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { propOr } from 'ramda';
import withStyles from 'react-jss';
import { isAfter } from 'date-fns';

import { Theme } from 'config';
import { ClassProp } from 'helpers/types';
import OfferSegmentDeleteModal from '../OfferSegmentDeleteModal';
import { useModal } from 'components/Modal/modalContext';

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  fieldValue: Date | string;
  record?: Record<string, any>;
  options?: Record<string, unknown>;
};

const styles = (theme: Theme) => ({
  icon: {
    cursor: 'pointer !important',
    color: `${theme.softGray} !important`,
  },
  button: {
    boxShadow: 'none !important',
  },
});

const OfferSegmentDeleteBtn: FunctionComponent<Props> = ({
  record,
  classes,
}) => {
  const { handleModal } = useModal();
  const startDate: string = propOr('', 'startDate', record);
  const endDate: string = propOr('', 'endDate', record);

  if (!isAfter(new Date(startDate), new Date()) || endDate === startDate) {
    return null;
  }

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handleModal(<OfferSegmentDeleteModal offerSegment={record} />, 'tiny');
  };

  return (
    <Button
      compact
      icon
      basic
      className={classes.button}
      onClick={handleOnClick}
    >
      <Icon name={'trash'} className={classes.icon} />
    </Button>
  );
};

export default withStyles(styles)(OfferSegmentDeleteBtn);
